import type { ContentfulAsset, IFaqAsset } from '@/types/contentful'

export const normalizeContentfulUrl = (url?: string) => {
  if (!url) return ''
  return url.startsWith('//') ? `https:${url}` : url
}

type ContentfulAssetLink = { sys?: { id?: string } }
type ContentfulAssetLike = ContentfulAsset | ContentfulAssetLink

export const buildAssetsById = (assets: ContentfulAsset[]) =>
  assets.reduce((acc: Record<string, ContentfulAsset>, asset) => {
    acc[asset.sys.id] = asset
    return acc
  }, {})

const getAssetId = (value: unknown) => {
  if (!value || typeof value !== 'object') return undefined
  return (value as ContentfulAssetLike).sys?.id
}

const getAssetFileUrl = (value: unknown) => {
  if (!value || typeof value !== 'object') return undefined
  return (value as ContentfulAsset).fields?.file?.url
}

export const resolveAssetUrl = (rawAsset: unknown, assetsById: Record<string, ContentfulAsset>) => {
  if (typeof rawAsset === 'string') return normalizeContentfulUrl(rawAsset)

  const assetId = getAssetId(rawAsset)
  const resolved = (assetId ? assetsById[assetId] : undefined) ?? rawAsset
  return normalizeContentfulUrl(getAssetFileUrl(resolved))
}

export const mapAssetsToSimple = (assets: ContentfulAsset[]): IFaqAsset[] =>
  assets.map((asset) => ({
    id: asset.sys.id,
    title: asset.fields.title ?? '',
    url: normalizeContentfulUrl(asset.fields.file?.url),
  }))


